import dayjs from 'dayjs';
import { convertMinutesToDurationFormat } from './convertMinutesToDurationFormat';

export function convertDatesToDurationFormat(dateFrom: string, dateTo: string) {
  const dateFromToDiffInMs = dayjs(dateTo).diff(dayjs(dateFrom));
  const diffInMsToMinutes = dateFromToDiffInMs / (1000 * 60);
  return convertMinutesToDurationFormat(diffInMsToMinutes);
}
